/**
 * CINEMATIC_ARCHETYPE
 *
 * The "Ground Truth" statistical profile for the Epic/Cinematic Genre.
 * Derived from latent analysis of orchestral scores (Zimmer, Williams, Holst).
 * Used by ScoringEngine to evaluate generated content.
 */

import { BASE_ARCHETYPE } from './BaseArchetype.js';

export const CINEMATIC_ARCHETYPE = {
    ...BASE_ARCHETYPE,

    // Voice Distribution: Ratio of activity (duration * velocity) across registers.
    // Cinematic mixes are often "Bottom Heavy" (Cellos/Basses/Brass) or "Ethereal Highs".
    // Mid-range clutter is the enemy.
    voiceDistribution: {
        ...BASE_ARCHETYPE.voiceDistribution,
        low: 0.40,  // Bass, Cello, Tuba, Timpani, Sub
        mid: 0.30,  // Violas, Horns (Support)
        high: 0.30, // Violins, Flutes (Lead)
        tolerance: 0.25 // Significantly wider tolerance for Bass Heavy mixes
    },

    // Motivic Repetition: Thematic cohesion across sections.
    // Themes should recur but allow for variation.
    motivicRepetition: {
        ...BASE_ARCHETYPE.motivicRepetition,
        target: 0.6
    }
};
